module.exports = __webpack_public_path__ + "static/img/gl-5.e98fdbe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gallery/gl-5.jpg
// module id = W+aq
// module chunks = 0